import OverallLSPM from "./OverallLSPM";

export default OverallLSPM;
